export default {
    '1_month_ago': "1 oydan kam",
    '12_months_ago': "12 oydan kam",
    '3_months_ago': "3 oydan kam",
    '6_months_ago': "6 oydan kam",
    above_1_month: "1 oydan ko‘p",
    above_1_year: "1 yildan ko‘p",
    above_2_months: "2 oydan ko‘p",
    above_3_months: "3 oydan ko‘p",
    above_6_months: "6 oydan ko‘p",
    add_patients: "Bemorlarni qo‘shish",
    add_standard: "Standart qo‘shish",
    after_one_day: "Bir kundan so‘ng",
    after_service: "Xizmatdan so‘ng",
    agreement_to_get_notifications_in_max: "MAX-da bildirishnomalarni olish uchun rozilik",
    all_statuses: "Barcha holatlar",
    amount_of_patients: "Bemorlar soni",
    april: "Aprel",
    are_you_sure_you_want_to_delete_mailing: "Haqiqatan ham tarqatma xatlarni o‘chirmoqchimisiz?",
    august: "Avgust",
    birth_day: "Tug'ilgan kun",
    birth_month: "Tug'ilgan oy",
    cannot_be_delivered: "Yetkazib berish mumkin emas",
    channel: "Kanal",
    channels: "Kanallar",
    complex_status_changed: "Davolash rejasidan kompleksning holatini o'zgartirish",
    create_mailing: "Tarqatma xatlar yaratish",
    december: "Dekabr",
    do_not_send_at_night_time: "Tun vaqtlarida yuborilmaydi (22:00 - 07:00)",
    does_not_contain: "Tarkibi yo'q",
    duplicate: "Nusxalash",
    february: "Fevral",
    given_time: "Berilgan vaqt",
    has_future_visit: "Kelgusi sanalar uchun tashrif mavjud",
    has_tags: "Belgiga ega",
    has_treatment_plan_with_status: "Holatga qarab davolanish rejasi mavjud",
    has_visit_with_status: "Mavqe bilan tashrifga ega",
    immediately_after_creating: "Yaratilgandan so‘ng darhol",
    january: "Yanvar",
    july: "Iyul",
    june: "Iyun",
    laboratory_order_status: "Ish tartibi holati",
    laboratory_order_status_changed: "Buyurtmaning holatini o'zgartirish",
    launch_mailing: "Tarqatma xatlarni ishga tushirish",
    mailing: "Tarqatma xat",
    mailing_date: "Tarqatma xat sanasi",
    mailing_report: "Tarqatma xatlar bo'yicha hisobot",
    mailings: "Tarqatma xatlar",
    march: "Mart",
    marketing: "Marketing",
    marketing_mailing: "Tarqatma xat",
    may: "May",
    no_push_token: "Token mavjud emas",
    not_enough_balance: "Hisobda mablag‘ yetarli emas",
    november: "Noyabr",
    october: "Oktyabr",
    of_days: "kunlar",
    of_hours: "soatlar",
    passed_since_last_visit: "Oxirgi tashrifdan beri o‘tdi",
    payments_were: "To‘lovlar amalga oshirildi",
    plan_status_changed: "Davolash rejasi holati o'zgardi",
    push_notification: "Push-bildirishnoma",
    push_notifications: "Push-bildirishnomalar",
    ready: "Tayyor",
    retry: "Yana bir marta urinib ko'rish",
    same_day: "Xuddi shu kuni",
    save_filter: "Filtrni saqlash",
    send_again: "Qayta yuborish",
    send_date: "Yuborish sanasi",
    send_info: "Yuborish to‘g‘risida ma’lumot",
    sent_slash_error: "Yuborildi / Xato",
    september: "Sentyabr",
    since_last_visit: "Oxirgi tashrifdan keyin",
    sms_message: "SМS-xabar",
    stop_mailing: "Xat tarqatishni to‘xtatish",
    tags_for_marketing_mailing: "Ma’lumotni avtomatik ravishda chiqarib olish uchun teglar:",
    task_title: "Vazifa nomi",
    time: "Vaqt",
    token: "Token",
    tokens: "Tokenlar",
    too_many_attempts: "Yuborish urinishlari juda koʻp",
    total_in_group: "Guruhda jami",
    treatment_plan_created: "Yangi davolash rejasi tuzildi",
    users_selected: "Tanlangan foydalanuvchilar",
    visit_time_changed: "Tashrif vaqti qayta rejalashtirilgan",
    wrong_credentials: "Yuborish xizmatining noto‘g‘ri avtorizatsiya qilingan ma’lumotlari",
    wrong_phone_number: "Noto‘g‘ri telefon raqami"
}
